import {spentWithinPeriod} from 'core/History';
import {periodOf} from 'core/Budget';

export function totalSpent(budget: Budget, history: HistoryLog): MoneyAmount {
  return spentWithinPeriod(history, periodOf(budget));
}
